enum accountStatusEnum {
  Pending,
  Active,
  Deactivate,
}

export default accountStatusEnum;
